import { render, staticRenderFns } from "./VisualisationFacture.vue?vue&type=template&id=58a84ba8&scoped=true&"
import script from "./VisualisationFacture.vue?vue&type=script&lang=js&"
export * from "./VisualisationFacture.vue?vue&type=script&lang=js&"
import style0 from "./VisualisationFacture.vue?vue&type=style&index=0&id=58a84ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a84ba8",
  null
  
)

export default component.exports